import { useContext } from 'react';

import { ProductTableContext } from '../components/ProductTableContext';

export const useProductTableConfig = () => {
    return useContext(ProductTableContext);
};
